var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ContainerImg, useStyles } from "./style";
import { IconAFY, sizesIcon, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
export var Icon = function (props) {
    var classes = useStyles();
    return (_jsx(_Fragment, { children: props.showIcon && (_jsx("div", __assign({ style: { margin: "0 0 0 5px" } }, { children: props.logoImg ? (_jsx(ContainerImg, { children: _jsx("img", { src: props.logoImg, alt: "logo", className: classes.imgLogo }) })) : (_jsx("div", __assign({ style: { marginTop: "5px" } }, { children: _jsx(IconAFY, { color: "#2d488d", icon: props.iconPage, size: sizesIcon.standard }) }))) }))) }));
};
